import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import CallAPI from '../../../../adminpanel/components/commonComponents/AxiosHelper';
import DataTableComponent from '../../commonComponents/DataTableComponent';
import LoadingComponent from '../../commonComponents/LoadingComponent';

const SavedModelComponent = ({ authData }) => {
    const [modelData, setModelData] = useState({
        data: [],
        enableSave: 0
    })
    const [errorMessage, setErrorMessage] = useState(null)
    const [loadingStatus, setLoadingStatus] = useState(false)
    let errorData = <h5 className="text-center mg-t-100">{errorMessage}</h5>;

    useEffect(() => {
        setTimeout(() => {
            feather.replace();
        }, 2)
    }, [modelData, loadingStatus])

    function getSavedData() {
        let params = { "siteId": authData.siteId, "companyName": authData.companyName }
        CallAPI('GET', '/app/fetch_modal_data', null, params, 0, function (response) {
            if (response.status === true) {
                let tempArray = response.information.map(el => {
                    let tempPostBody = JSON.parse(el.post_body)
                    if (tempPostBody !== null) {
                        el.post_body = tempPostBody
                        el.modelName = tempPostBody.name
                    }
                    return el
                })
                setModelData({ ...modelData, data: tempArray, enableSave: 0 }),
                    setErrorMessage(null);
            } else {
                setErrorMessage(response.error_message)
                setModelData({ ...modelData, data: response.status, enableSave: 0 })
            }
        }, authData)
    }

    useEffect(() => {
        getSavedData()
    }, [])

    const handleUpdate = (inputValue, rowNumber, data, columnName) => {
        let tempObject = [...tableData];
        let valueToCheck = 'modal_name';
        let checkValidity = true
        checkValidity = columnName === 'modal_name' ? (checkSpecialChars(inputValue) ? false : true) : true
        if (checkValidity === false) {
            alert('Please enter valid input!\n(Only alphabets, numbers, hyphen(-) & underscore(_) are allowed.)');
        } else {
            tempObject.map(individualObj => {
                if (individualObj[valueToCheck] === data[valueToCheck] && individualObj['id'] === data['id']) {
                    if (columnName == "merged_frequency") {
                        individualObj["merged_frequency"] = {
                            "freq_type": inputValue.type,
                            "timeOfDay": inputValue.time,
                            "dayOfWeek": inputValue.dayOfWeek,
                            "dayOfMonth": inputValue.dayOfMonth
                        }
                        individualObj["merged_frequency"] = JSON.stringify(individualObj["merged_frequency"]);
                    } else if (columnName === "modal_name") {
                        individualObj[`${columnName}`] = inputValue;
                    } else {
                        individualObj[`${columnName}`] = inputValue[`${columnName}`];
                    }
                    if (individualObj['rockmetric_update_columns'] === null || individualObj['rockmetric_update_columns'] === undefined) {
                        individualObj['rockmetric_update_columns'] = [];
                    }
                    if (individualObj['rockmetric_update_columns'].indexOf(columnName) === -1) {
                        individualObj['rockmetric_update_columns'].push(columnName)
                    }
                }
            });
            setModelData({ data: tempObject, enableSave: 1 });
        }
    }

    const handleSaveButton = (e) => {
        let params = {
            siteId: authData.siteId
        }
        let url = '/app/update_table_info';
        let postData = [];
        tableData.map(innerData => {
            if (innerData.rockmetric_update_columns) {
                let tempObject = {
                    "id": innerData.id,
                    "target": "merged_modals",
                    "rockmetric_update": innerData.rockmetric_update_columns ? true : false,
                    "rockmetric_update_columns": innerData.rockmetric_update_columns ? innerData.rockmetric_update_columns : []
                }
                if (innerData.isActive !== null && innerData.rockmetric_update_columns.indexOf('isActive') > -1) {
                    tempObject['isActive'] = innerData.isActive
                }
                if (innerData.modal_name !== null && innerData.rockmetric_update_columns.indexOf('modal_name') > -1) {
                    tempObject['modal_name'] = innerData.modal_name
                }
                if (innerData.merged_frequency !== null && innerData.rockmetric_update_columns.indexOf('merged_frequency') > -1) {
                    tempObject['merged_frequency'] = (JSON.parse(innerData.merged_frequency).freq_type === "once" || JSON.parse(innerData.merged_frequency).freq_type === "daily") ? { "freq_type": JSON.parse(innerData.merged_frequency).freq_type, "timeOfDay": JSON.parse(innerData.merged_frequency).timeOfDay } : (JSON.parse(innerData.merged_frequency).freq_type === "weekly" || JSON.parse(innerData.merged_frequency).freq_type === "week") ? { "freq_type": JSON.parse(innerData.merged_frequency).freq_type, "timeOfDay": JSON.parse(innerData.merged_frequency).timeOfDay, "dayOfWeek": JSON.parse(innerData.merged_frequency).dayOfWeek } : (JSON.parse(innerData.merged_frequency).freq_type === "monthly") ? { "freq_type": JSON.parse(innerData.merged_frequency).freq_type, "timeOfDay": JSON.parse(innerData.merged_frequency).timeOfDay, "dayOfMonth": JSON.parse(innerData.merged_frequency).dayOfMonth } : null
                }
                postData.push(tempObject);
            }
        });
        setLoadingStatus(true);
        CallAPI('post', url, postData, params, 0, function (response) {
            if (response.information[0].status === true) {
                alert(response.information[0].information);
                setLoadingStatus(false);
                setModelData({ ...modelData, enableSave: 0 })
                getSavedData()
            } else {
                alert(response.error_message[0].information);
                setLoadingStatus(false);
                setModelData({ ...modelData, enableSave: 0 })
            }
        }, authData);
    }

    let topButton = [
        {
            "name": "Save",
            "className": `btn btn-primary btn-sm mg-r-10 text-white ${modelData.enableSave ? null : "disabled"}`,
            "event": handleSaveButton,
            "key": `executeData${Math.floor(Math.random() * 10)}`,
            "loadingStatus": loadingStatus,
            "type": "add",
            "icon": "pocket"
        }
    ];

    const handleRunButton = (row) => {
        let params = {
            "id": row.id
        }
        let url = '/app/v1/process_merge_modal';
        if (confirm("Are you sure you want to run the model?")) {
            CallAPI("GET", url, null, params, 0, function (response) {
                if (response.status === true) {
                    alert(response.information);
                    getSavedData();
                } else {
                    alert(response.error_message[Object.keys(response.error_message)[0]].message);
                }
            }, authData)
        }
    }

    let columnData = [
        { "virtualName": "Model Name", "edit": "input", "rawField": "modal_name", "minWidth": "220px" },
        { "virtualName": "Owner", "rawField": "username", "type": "avtar", "minWidth": "160px" },
        { "virtualName": "Created Date", "rawField": "created_time", "displayType": "date" },
        { "virtualName": "Frequency", "rawField": "merged_frequency", "edit": "mulitpleInput", "displayType": "both", "minWidth": "280px" },
        { "virtualName": "Last Runtime", "rawField": "executed_time", "displayType": "dateTime" },
        {
            "virtualName": "Status", "rawField": "isActive", "maxWidth": "110px", "edit": "dropDown", "displayType": "dropDown", "options": {
                "1": { "name": "Active", "value": "1" },
                "0": { "name": "Inactive", "value": "0" }
            }
        },
        {
            "virtualName": "Actions", "rawField": "information", "maxWidth": "100px", type: "tableCell", tableCell: (row, id, column, index) => {
                let DBName = `customer_${row['siteId']}_file_uploaded`;
                let tableName = row['table_name'] ? row['table_name'] : null;
                let connectionId = row['connectionId'] ? row['connectionId'] : null;
                return <>
                    <div className="dropdown-file" style={{ position: 'static' }}>
                        <a href="" className="dropdown-link mx-2" data-toggle="dropdown"><i className="fas fa-caret-down"></i></a>
                        <div className="dropdown-menu" >
                            <a href="javascript:void(0)" className="dropdown-item" onClick={handleRunButton ? () => handleRunButton(row) : null} style={{ backgroundColor: "#5B9DFC", color: "white" }} ><i className="fas fa-play mx-2" style={{ color: "white" }}></i>Run</a>
                            <div className={`dropdown-item details ${tableName === null ? 'disabled btn btn-secondary' : null}`}>
                                <i className="far fa-copy mx-2"></i>
                                <Link to={`/adminpanel/v2/view_connection_data/${DBName}/${tableName}/${connectionId}`} target="_blank">View</Link>
                            </div>
                        </div>
                    </div>
                </>
            }
        }
    ]
    let displayInformation = { "displaySentence": "Run particular Merge Model to enable corresponding View Action" };
    let tableData = modelData.data ? modelData.data : null

    return (
        modelData.data && errorMessage === null ?
            <>
                <DataTableComponent
                    columnData={columnData}
                    tableData={tableData}
                    topButton={topButton}
                    setTableData={handleUpdate}
                    addFilter={true}
                    filterColumnName={'modal_name'}
                    informationTag={displayInformation}
                />
            </>
            : modelData.data === false && errorMessage ? errorData : <LoadingComponent />
    )
}

function mapStateToProps(state) {
    return { authData: state.dataSet.authData };
    //return { authData: { ...state.dataSet.authData, ...{ "toolId": state.dataSet.dataSet.toolId } } };
}

export default connect(mapStateToProps, null)(SavedModelComponent);
